import React, { Component } from 'react';
import { HashAnchor } from './components/atoms';
import NewView from './components/views/NewView';
import {
	AboutView,
	CaseStudiesView,
	CaseStudiesVisualExpiriencesView,
	ContactUsView,
	FooterView,
	GetInTouchView,
	HeaderView,
	OurClientsView,
	LearnMoreView,
	HeroView,
	HowItWorksView,
	QuotesView,
	SeeHowView,
	// TrialOfferView,
	UploadVisualsView,
	LearnTestExportView,
	WatchTaggisView,
	WhoWeAreView,
	TaggisAndDocBrowserView,
} from './components/views';

const SUPPORTS_INTERSECTION_OBSERVER =
	typeof IntersectionObserver !== 'undefined';
const THRESHOLD = 0.95;

class TaggisElearningLanding extends Component {
	state = {
		showOpaqueHeader: false,
	};

	componentDidMount () {
		window.scrollTo(0, 0);
		this.setupIntersectionObserver();
	}

	componentWillUnmount () {
		this.io.disconnect();
	}

	handleThresholdMatch (entries) {
		const [{ intersectionRatio }] = entries;
		this.setState({
			showOpaqueHeader: intersectionRatio <= THRESHOLD,
		});
	}

	heroRef = React.createRef();

	setupIntersectionObserver = async () => {
		if (!SUPPORTS_INTERSECTION_OBSERVER) {
			await import('intersection-observer');
		}
		this.io = new IntersectionObserver(
			this.handleThresholdMatch.bind(this),
			{
				threshold: [THRESHOLD],
			}
		);
		this.io.observe(this.heroRef.current);
	};

	render () {
		return (
			<main>
				<HeaderView opaque={this.state.showOpaqueHeader} />
				<HeroView forwardedRef={this.heroRef} />
				<AboutView />
				<HashAnchor id='projects' />
				<CaseStudiesView />
				<CaseStudiesVisualExpiriencesView />
				{/* <HashAnchor id='free-trail' />
				<TrialOfferView /> */}
				<HashAnchor id='clients' />
				<OurClientsView />
				<WatchTaggisView />
				<UploadVisualsView />
				<LearnTestExportView />
				<LearnMoreView />
				<QuotesView />
				<HashAnchor id='camera' />
				<HowItWorksView />
				<SeeHowView />
				<WhoWeAreView />
				<TaggisAndDocBrowserView />
				<NewView />
				<HashAnchor id='about' />
				<GetInTouchView />
				<ContactUsView />
				<FooterView />
			</main>
		);
	}
}

export default TaggisElearningLanding;



// WEBPACK FOOTER //
// ./src/TaggisElearningLanding.js